
import Button from '../../../components/base/Button';

export default function AreaInfoSection() {
  const areas = [
    {
      id: 'shibuya',
      name: '渋谷区',
      description: 'ファッションと文化の最先端エリア。交通アクセス抜群で、若者からファミリーまで人気の住宅地。',
      highlights: ['渋谷駅周辺の再開発', '恵比寿・代官山の高級住宅地', '原宿・表参道の商業施設'],
      averagePrice: '約70万円/㎡',
      image: 'https://public.readdy.ai/ai/img_res/90b4c2b094e5d02d27ce87bfda783586.jpg.%20The%20scene%20should%20capture%20the%20dynamic%20energy%20and%20urban%20sophistication%20of%20Tokyo%20premier%20district%20with%20architectural%20landmarks%20and%20vibrant%20street%20life.&width=300&height=200&seq=area-shibuya&orientation=landscape'
    },
    {
      id: 'minato',
      name: '港区',
      description: '東京のビジネス中心地であり高級住宅エリアとしても人気。国際色豊かで洗練された街並み。',
      highlights: ['六本木・赤坂の高級タワーマンション', '青山・麻布の閑静な住宅地', '汐留・お台場の湾岸エリア'],
      averagePrice: '約85万円/㎡',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20upscale%20residential%20area%20in%20Minato%20district%20featuring%20luxury%20condominiums%2C%20tree-lined%20streets%2C%20and%20sophisticated%20urban%20planning.%20The%20scene%20should%20showcase%20the%20premium%20nature%20of%20Tokyo%20prestigious%20district%20with%20modern%20architecture%2C%20well-maintained%20parks%2C%20and%20high-end%20commercial%20facilities%20during%20soft%20morning%20light.&width=300&height=200&seq=area-minato&orientation=landscape'
    },
    {
      id: 'setagaya',
      name: '世田谷区',
      description: '緑豊かな住宅地として人気。ファミリー層に最適な落ち着いた環境と充実した教育施設。',
      highlights: ['成城・田園調布の高級住宅地', '二子玉川の商業・住宅複合地', '下北沢・三軒茶屋の文化エリア'],
      averagePrice: '約55万円/㎡',
      image: 'https://readdy.ai/api/search-image?query=Peaceful%20residential%20neighborhood%20in%20Setagaya%20with%20tree-lined%20streets%2C%20family-friendly%20parks%2C%20traditional%20and%20modern%20houses%20harmoniously%20blended.%20The%20scene%20should%20convey%20a%20sense%20of%20community%2C%20green%20spaces%2C%20and%20quality%20family%20living%20with%20children-friendly%20facilities%20and%20quiet%20suburban%20atmosphere.&width=300&height=200&seq=area-setagaya&orientation=landscape'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            対応エリアのご紹介
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            長年の実績と地域密着で培った各エリアの魅力をご紹介
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-8">
          {areas.map((area) => (
            <div key={area.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-48 overflow-hidden">
                <img
                  src={area.image}
                  alt={area.name}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform"
                />
              </div>
              
              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <h3 className="text-2xl font-bold text-gray-900">
                    {area.name}
                  </h3>
                  <div className="text-sm bg-blue-100 text-blue-600 px-3 py-1 rounded-full font-semibold">
                    {area.averagePrice}
                  </div>
                </div>
                
                <p className="text-gray-600 mb-4 leading-relaxed">
                  {area.description}
                </p>
                
                <div className="mb-6">
                  <h4 className="font-semibold text-gray-900 mb-2">エリアの特徴</h4>
                  <ul className="space-y-1">
                    {area.highlights.map((highlight, index) => (
                      <li key={index} className="flex items-start text-sm text-gray-600">
                        <i className="ri-map-pin-line text-blue-600 mr-2 mt-0.5 flex-shrink-0"></i>
                        {highlight}
                      </li>
                    ))}
                  </ul>
                </div>
                
                <Button variant="outline" className="w-full">
                  {area.name}の物件を見る
                </Button>
              </div>
            </div>
          ))}
        </div>
        
        <div className="text-center">
          <Button size="lg" className="px-8">
            全対応エリアを見る
          </Button>
        </div>
      </div>
    </section>
  );
}
